<template lang="pug">
  v-container(fluid)
    h2.text-center Finanzas

    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header Filtro
            v-expansion-panel-content
              v-container.py-0(fluia)
                form
                  v-row
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(label="From")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(label="To")
                    v-col.py-0.text-right(cols="12")
                      v-btn(text color="primary")
                        v-icon.mr-2 mdi-magnify
                        | Filtrar
      v-divider
      v-col(cols="12")
        //v-progress-linear(color="primary" :active="isLoading" indeterminate)
        v-simple-table
          template(default)
            thead
              tr
                th Id
                th Tipo
                th Pagado
                th Fecha
                th
            tbody(ref="roundData")
              tr(v-for="(round,i) in 15" :key="i")
                td {{round}}
                td Operador
                td Si
                td 2020-05-{{round}}
                td
                  v-btn(text color="primary")
                    v-icon mdi-information-outline
      BaseDialog(v-if="hasPermission('views.finances.createInvoice')" type="create", :title="translationsInvoice.title.create" v-slot="{close, opened}")
        InvoiceCreate(@successCreate="updateSomething(opened,close)", :clearForm="opened", :providersListAll="providersListAll", :operatorsListAll="operatorsListAll", :translations="translationsInvoice")
</template>

<script>

  import InvoiceCreate from "@/components/forms/InvoiceCreate";

  export default {
    name: 'FinancesHome',
    components: {
      InvoiceCreate,
    },
    computed: {
      translationsInvoice(){
        return this.$t("forms.invoice");
      },
      providersListAll(){
        return this.$store.state.providers.map(provider => {
          return{
            text: provider.n,
            value: `${provider._id}`,
          }
        })
      },
      operatorsListAll(){
        return this.$store.state.operators.map(provider => {
          return{
            text: provider.n,
            value: `${provider._id}`,
          }
        })
      },
    },
    created() {
      this.$store.dispatch('getProviders');
      this.$store.dispatch('getOperators');
      this.$store.dispatch('getPayout');

    }
  }
</script>

<style lang="scss">
  .invoice__table {
    th {
      border: 0;
    }
    tfoot {
      td {
        border-width: 1px 0 0;
      }
    }
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-leave-active {
    transition: opacity 1s;
    opacity: 0;
  }
  .finance__paymentDetails__card__header{
    color:white;
   }
  .finance__paymentDetails__card__details{
    background-color: #F5F5F5!important;
  }
  .finance__invoice{
    border:1px solid #82828263;
  }
</style>